import { HttpWebGet } from "../Net/HttpNetMg";
import Common from "./Common";

export default class ProductData{
    private static instance: ProductData;
    public static get Instance():ProductData{
        if(!this.instance){
            this.instance = new ProductData();
        }
        return this.instance;
    }
    private isLoaded:boolean;
    private products:any;
    private menus:any;
    private brands:any;
    private menuIndex:number;
    private brandName:string;
    constructor(){
        this.products = null;
        this.isLoaded = false;
        this.menuIndex = 0;
        this.brandName = "All";
    }

    public get Products():any{
        return this.products;
    }

    public get Menus():any{
        return this.menus;
    }

    public get Brands():any{
        return this.brands;
    }

    public get MenuIndex():number{
        return this.menuIndex;
    }

    public set MenuIndex(v:number){
        this.menuIndex = v;
        this.brandName = "All";
        Common.Product = this;
    }

    public get BrandName():string{
        return this.brandName;
    }

    public set BrandName(v:string){
        this.brandName = v;
        Common.Product = this;
    }

    public get IsLoaded():boolean{
        return this.isLoaded;
    }

    public async GetProduct(){
        if(!this.products){
            const {status, text} = await HttpWebGet('/product/product.json');
            if(status === 200){
                this.products = JSON.parse(text);
                if(this.menus){
                  this.isLoaded = true;
                }
                Common.Product = this;
            }
        }
    }

    public GetProductById(productid:string){
        if(this.products){
            for (let index = 0; index < this.products.length; index++) {
                if(this.products[index].ProductId === productid){
                    return this.products[index];
                }
            }
        }
        return null;
    }

    public async GetMenus(){
        if(!this.menus){
            const {status, text} = await HttpWebGet('/product/menu.json');
            if(status === 200){
                let menudt = JSON.parse(text);
                this.menus = menudt.menus;
                this.brands = menudt.brands;
                if(this.products){
                  this.isLoaded = true;
                }
                Common.Product = this;
            }
        }
    }
}